import React from "react";
import TracerouteGlobe from "./Globe";

function App() {
  return (
    <div className="App">
      <TracerouteGlobe />
    </div>
  );
}

export default App;